var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"accordion",staticClass:"accordion"},[_c('AccordionEventListener',{on:{"update:state":function($event){return _vm.handleStateChange($event)}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }